import React from "react";
import { Button, Card, Icon, Image } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import DOMPurify from "dompurify";
import { bool, func } from "prop-types";
import { connect } from "react-redux";
import { ProductLineTagDescriptionShape } from "../../shapes/productLine.shape";
import SubLineItemPicker from "../roomBook/pickers/SubLineItemPicker";
import { SubLineItemShape } from "../configurator/roomBook.shape";
import { getActiveProductTag } from "../../selectors/unit/productLines";
import { getSubLineItemForProductLineTag } from "../../selectors/unit/subLineItems";
import { ProductOptionShape } from "../../shapes";

function ProductTagModalCard({
  tagDescription,
  subLineItem,
  isActive,
  productOption,
  onSelect
}) {
  const {
    id: tagDescriptionId,
    images,
    displayName,
    description: unsafeHtmlDescription
  } = tagDescription;

  const handleProductLineSelect = selectProductOption => {
    return () => {
      if (isActive) {
        onSelect(tagDescriptionId);
      } else {
        selectProductOption(productOption).then(apiResponse => {
          if (apiResponse !== undefined) onSelect(tagDescriptionId);
        });
      }
    };
  };

  const selectedString = (
    <>
      &nbsp;(
      <FormattedMessage
        id="meta.actions.selected"
        defaultMessage="Ausgewählt"
      />
      )
    </>
  );

  if (!(subLineItem && productOption)) return <></>;
  return (
    <SubLineItemPicker subLineItem={subLineItem}>
      {({ select: selectProductOption, loadingId }) => {
        return (
          <Card raised={isActive} data-component="productTagModalCard">
            <Image src={images?.[0]} />
            <Card.Content>
              <Card.Header>
                {displayName}
                {isActive && selectedString}
              </Card.Header>
              <Card.Description>
                {/* We sanitize the value */}
                {/* eslint-disable react/no-danger */}
                <p
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(unsafeHtmlDescription)
                  }}
                />
                {/* eslint-enable react/no-danger */}
              </Card.Description>
            </Card.Content>
            <Card.Content textAlign="right">
              <Button
                basic
                icon
                disabled={!!loadingId}
                labelPosition="right"
                loading={!!loadingId}
                onClick={handleProductLineSelect(selectProductOption)}
              >
                <FormattedMessage
                  id="buyerPortal.roomBook.productLine.actions.select"
                  values={{ displayName }}
                />
                <Icon name="right arrow" />
              </Button>
            </Card.Content>
          </Card>
        );
      }}
    </SubLineItemPicker>
  );
}
ProductTagModalCard.propTypes = {
  tagDescription: ProductLineTagDescriptionShape.isRequired,
  subLineItem: SubLineItemShape,
  isActive: bool.isRequired,
  onSelect: func,
  productOption: ProductOptionShape
};

ProductTagModalCard.defaultProps = {
  subLineItem: undefined,
  productOption: undefined,
  onSelect: () => {}
};

const mapStateToProps = (state, props) => {
  const tagId = props.tagDescription.id;
  const activeProductTag = getActiveProductTag(state, props);
  const isActive = activeProductTag === tagId;
  const subLineItem = getSubLineItemForProductLineTag(state)(tagId);
  if (!subLineItem) {
    // give a hint why no ProductCard is displayed
    // eslint-disable-next-line no-console
    console.warn(`Could not find any matching subLineItem for tag ${tagId}`);
  }

  const productOption = subLineItem?.options.find(({ productTags }) =>
    productTags.includes(tagId)
  );

  return { isActive, subLineItem, productOption };
};

export default connect(mapStateToProps)(ProductTagModalCard);
